<template>
  <span class="theme-marker" :title="`Active Icarus theme: ${theme}`">{{ theme }}</span>
</template>

<script>
// io-branding B.7 — reference theme marker. A trivial component that exists
// only to (a) prove the theme tier loads when ICARUS_THEME=reference and
// (b) keep src/themes/ non-empty so require.context resolves. Real themes
// add component files here whose PascalCase names match a project/core
// component to OVERRIDE it (theme > project > core), or new names to add.
export default {
  name: 'ThemeMarker',
  computed: {
    theme() {
      return (typeof ICARUS_THEME !== 'undefined' && ICARUS_THEME) ? ICARUS_THEME : 'none';
    },
  },
};
</script>
